import type { MailboxInfo } from 'owa-client-types';
import type { PickerType } from '../store/schema/CopilotAccountPickerStoreSchema';
import { setCurrentAccountMutator } from '../mutators/accountPickerMutators';
import { onCopilotAccountPickerSwitched } from '../actions/onCopilotAccountPickerSwitched';

export function setCurrentAccount(
    account: MailboxInfo,
    targetWindow: Window,
    pickerOrigin: PickerType
): void {
    setCurrentAccountMutator(account);
    onCopilotAccountPickerSwitched(account, targetWindow, pickerOrigin);
}
